import { ROUTE_CATALOG, ROUTE_CATALOG_CATEGORIES, ROUTE_CATALOG_PRODUCT_REVIEWS, ROUTE_ORDERS, ROUTE_ORDERS_FEEDBACKS, ROUTE_ORDERS_ON_MAP, ROUTE_PRODUCT_GROUPS } from '@@partner:config/routes'
import { usePartner } from '@@partner:helpers/hooks/auth'
import React from 'react'
import { AppsOutline, CartOutline, LayersOutline, Map, MapOutline, StarOutline } from 'react-ionicons'
import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'


export default function OrdersPageTopMenu () {
  const { brandSlug } = usePartner()

  return (
    <Navbar>
      <Nav>
        <Nav.Item
          icon={<CartOutline />}
          as={NavLink}
          to={generatePath(ROUTE_ORDERS, { brandSlug })}
        >
          Заказы
        </Nav.Item>
        <Nav.Item
          icon={<MapOutline />}
          as={NavLink}
          to={generatePath(ROUTE_ORDERS_ON_MAP, { brandSlug })}
        >
          На карте
        </Nav.Item>
        <Nav.Item
          icon={<StarOutline />}
          as={NavLink}
          to={generatePath(ROUTE_ORDERS_FEEDBACKS, { brandSlug })}
        >
          Отзывы
        </Nav.Item>
      </Nav>
    </Navbar>
  )
}